import { ConditionApi } from './condition-api';

export class OracleTextConditionApi extends ConditionApi {

  setValue (selectedScore, oracleTextExpression) {
    const rows = [ [ oracleTextExpression ] ];
    return super.setValue(rows, { score: String(selectedScore) });
  }

}
